<template>
  <div class="course-container">
    <Wrapper>
        <template slot="pc">
          <pcAppDownLoad />
        </template>
        <template slot="mobile">
          <mobAppDownLoad />
        </template>
    </Wrapper>
  </div>  
</template>
<script>
import mobAppDownLoad from './mobAppDownLoad';
import pcAppDownLoad from './pcAppDownLoad';
export default {
  data() {
    return {
      
    };
  },
  created() {
    // this.ideas = ['以用户为中心', '坚持母语教学', '贯彻因材施教', '培养核心价值'];
  },
  components: {
    mobAppDownLoad, pcAppDownLoad
  }
};
</script>
<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/pages/appDownLoad/partnerDownLoad.vue